<template>
  <div>
    <div v-for="(protocolClient, index) in clients" :key="index">
      <div class="p-d-flex p-col-12 line-content line-of-client p-mb-2">
        <div class="text-vertical-center">
          <a class="cursor-pointer" :href="`#/client/${protocolClient.client.id}/details`">{{protocolClient.client.name}}</a>
        </div>
        <div class="p-ml-auto text-vertical-center small" style="min-width: fit-content;">
            {{$n(pricePerClients[protocolClient.client.id], 'currency')}}
          <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" @click.prevent="addService(protocolClient, index)"><i class="p-ml-2 pi pi-plus-circle small" :title="$t('protocol.tab-services.add-service')"/></a>
          <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" @click.prevent="editClient(protocolClient, index)"><i class="p-ml-2 pi pi-pencil small" :title="$t('protocol.tab-services.edit-client')"/></a>
          <a v-if="loggedUser.typeUser !== limited" class="cursor-pointer" @click.prevent="removeClient(protocolClient, index)"><i class="p-ml-2 pi pi-times small" :title="$t('protocol.tab-services.remove-client')"/></a>
        </div>
      </div>
      <template>
        <display-service-client class="p-col-12 p-md-11 p-lg-10 float-right" :protocol="protocol" :protocolClient="protocolClient" :price-per-client="pricePerClients[protocolClient.client.id]" />
      </template>
    </div>
    <div class="p-col-12 line-content line-of-client p-mb-2 text-center" v-if="clients.length === 0">
      {{$t('protocol.tab-services.no-client')}}
    </div>

  </div>
</template>

<script>
import ProtocolBusiness from "@/business/ProtocolBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import EventBus from "@/commons/EventBus";
import CardFormClient from "@/viewer/protocol/tabs/services/CardFormClient";
import DisplayServiceClient from "@/viewer/protocol/tabs/services/DisplayServiceClient";
import CardFormService from "@/viewer/protocol/tabs/services/CardFormService";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
import store from "@/store";
import {LIMITED} from "@/constants/TypeUser";

export default {
  name: "DisplayProtocolClient",
  components: {DisplayServiceClient},
  props:{
    protocol:{type: Object, default: () => {}}
  },

  beforeMount() {
    EventBus.$on('OPEN_ADD_CLIENT_PROTOCOL', this.addClient);
  },

  beforeDestroy(){
    EventBus.$off('OPEN_ADD_CLIENT_PROTOCOL');
  },

  data(){
    return{
      clients: [],
      pricePerClients: {},
      limited: LIMITED,
      loggedUser: store.getLoggedUser(),
    }
  },

  async mounted() {
    await this.getClientsProtocol();
    await this.calculatePricePerClient();
    EventBus.$on('SERVICES_PROTOCOL_UPDATED', this.calculatePricePerClient);
  },

  destroyed() {
    EventBus.$off('SERVICES_PROTOCOL_UPDATED');
  },

  methods:{

    async removeClient(protocolClient, index){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await ProtocolBusiness.deleteProtocolClient(this.protocol.id, protocolClient.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          this.clients.splice(index, 1);
          ToastMessageBusiness.showSuccess();
          await this.calculatePricePerClient();
        }
      }
    },

    addClient(){
      EventBus.$emit('CHANGE_COMPONENT_EDITOR', {
        currentComponent: CardFormClient,
        paramComponent: {clientsProtocolId: this.clients.map((clientProtocol) => clientProtocol.client.id)},
        callBack: (response) => {
          this.clients.push(response);
          this.calculatePricePerClient();
        },
      });
    },

    editClient(client, index){
      EventBus.$emit('CHANGE_COMPONENT_EDITOR', {
        currentComponent: CardFormClient,
        paramComponent: {protocolClient: client, clientsProtocolId: this.clients.map((clientProtocol) => clientProtocol.client.id)},
        callBack: (response) => {
          this.$set(this.clients, index, response);
          this.addClient();
          this.calculatePricePerClient();
        },
      });
    },

    addService(protocolClient){
      EventBus.$emit('CHANGE_COMPONENT_EDITOR', {
        currentComponent: CardFormService,
        paramComponent: {client: protocolClient.client},
        callBack: (response) => {
          EventBus.$emit('UPDATE_SERVICE_CLIENT_LIST', {protocolClient, response});
          this.calculatePricePerClient();
        },
      });
    },

    async getClientsProtocol(){
      const clientsProtocol = await ProtocolBusiness.clientsOfProtocol(this.protocol.id);
      this.clients.push(...clientsProtocol);
    },

    async calculatePricePerClient() {
      let pricePerClient = await ProtocolBusiness.getPricePerPerson(this.protocol.id);
      this.clients.forEach(protocolClient => {
        this.$set(this.pricePerClients, protocolClient.client.id, pricePerClient);
      });
    }

  }
}
</script>

<style scoped>

  .line-of-client {
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto;
  }

</style>